import React, { useMemo, useState } from "react";
import _ from "lodash";
import CardHeader from "./common/CardHeader";
import CardSubheader from "./common/CardSubheader";
import constants from "../../config/constants";
import CardPreviewImage from "./common/CardPreviewImage";
import CardContent from "./common/CardContent";
import CardFilterPills from "./common/CardFilterPills";
import AudioPlayer from "../common/AudioPlayer";
import CardFooter from "./common/CardFooter";
import ShortFeedItem from "../common/ShortFeedItem";
import LogsService from "../../utils/logs";
import getEnvEndpoints from "../../utils/endpoints";
import { previewImageOfPost, mtStandardsBooks } from "../../utils/helper";

const endpoinds = getEnvEndpoints();

const Article = ({
  post,
  lookup,
  showPmbokModal,
  showShareModal,
  showFeedbackModal,
  cardFilterSelected,
  canProceed,
  isAuthenticated,
  playlists,
  feedbackSentContentKeys,
  fullcard,
  propGroup,
  userLikes,
  feedbacks,
  contentKey,
  id
}) => {
  const [expanded, setExpanded] = useState(false);

  const additionalMedia = useMemo(() => {
    return _.find(post.referenceFiles, {
      fileKey: constants.fileKey.additionalMedia,
    });
  }, [post.referenceFiles]);

  const isValidContent = useMemo(() => {
    let div = document.createElement("div");
    div.innerHTML = post.fullContent?.trim();
    let textContent = div.firstChild.textContent;
    return !!textContent;
  }, [post.fullContent]);

  const toggleExpand = async () => {
    if (!canProceed() || !isValidContent) return;

    if (!expanded) {
     if (post.isPublic && post.publishUntilDate && !((post.isPublic) && (new Date (post.publishUntilDate) > new Date()) )) {
        LogsService.logViewItem({
          contentKey: post.contentKey,
          contentSubType: post.contentType,
        })
          .then(() => { })
          .catch(() => { });
      }
    }

    setExpanded(!expanded);
  };

  const audioFileUrl = additionalMedia
    ? endpoinds.baseContentUrl + additionalMedia.filePath
    : "";
  const previewImage = previewImageOfPost(post);

  return (
    <>
      {fullcard ? (
        <div
          className={
            "flex border border-gray-500 rounded-sm mb-5 " +
            (post.status !== "Published" ? "bg-gray-400" : "bg-white")
          }
        >
          <div className="w-full">
            <CardHeader
              post={post}
              showPmbokModal={showPmbokModal}
              canProceed={canProceed}
              booksList={mtStandardsBooks(lookup, "MTStandardsGuide")}
            />

            <div className="px-5 mt-4">
              <div
                className={isValidContent ? "cursor-pointer" : ""}
                onClick={toggleExpand}
              >
                <CardSubheader subheader={post.title} isExpandable={false} />
              </div>
              {additionalMedia && (
                <AudioPlayer url={audioFileUrl} canProceed={canProceed} />
              )}

              {previewImage && (
                <div
                  className={isValidContent ? "cursor-pointer" : ""}
                  onClick={toggleExpand}
                >
                  <CardPreviewImage previewImage={previewImage?.filePath || previewImage} />
                </div>
              )}

              <CardContent
                post={post}
                isExpandable={isValidContent}
                expanded={expanded}
                setExpanded={toggleExpand}
              />

              <CardFilterPills
                post={post}
                lookup={lookup}
                canProceed={canProceed}
                cardFilterSelected={cardFilterSelected}
              />
            </div>

            <CardFooter
              post={post}
              showShareModal={showShareModal}
              showFeedbackModal={showFeedbackModal}
              canProceed={canProceed}
              isAuthenticated={isAuthenticated}
              feedbackSentContentKeys={feedbackSentContentKeys}
              playlists={playlists}
              propGroup={propGroup}
              feedbacks={feedbacks}
              userLikes={userLikes}
              contentKey={contentKey}
              id={id}
            />
          </div>
        </div>
      ) : (
        <ShortFeedItem post={post} />
      )}
    </>
  );
};

export default Article;
